module.exports = __webpack_public_path__ + "static/img/AdobeStock_480886056_2.3dc494f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/AdobeStock_480886056_2.png
// module id = hidX
// module chunks = 1